module.exports = __webpack_public_path__ + "img/9788993094701.e6ffa208.jpg";